import { render, staticRenderFns } from "./BAEdit.vue?vue&type=template&id=40667678&"
import script from "./BAEdit.vue?vue&type=script&lang=js&"
export * from "./BAEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports